// extracted by mini-css-extract-plugin
module.exports = {"personContainer":"SupportTeamComponent_personContainer__ldwGQ"};